export default {
	methods: {
		Ajax(url, method, data = {}, config = {}, form = null) {

			if (form && form.errors) {
				for (let field in form.errors) {
					form.errors[field] = null;
				}
			}

			let defaultConfig = {
				url,
				method,
				data,
				error: (xhr) => {
					let errors = xhr.responseJSON ? xhr.responseJSON.errors : null;

					if (errors && form && form.errors) {
						this.showToast(
							'Er zijn fouten opgetreden, controleer uw invoer en probeer het nog een keer',
							'danger'
						);
						for (let field in errors) {
							form.errors[field] = errors[field][0];
						}
					} else {
						let message = xhr.responseJSON && xhr.responseJSON.message
							? xhr.responseJSON.message
							: 'Er is iets misgegaan.';
						this.showToast(message, 'danger');
					}
				},
			};

			return $.ajax(Object.assign({}, defaultConfig, config));
		},

		submitForm(url, method, form, config = {}) {
			let mergedConfig = Object.assign({
				contentType: 'application/json',
				processData: false,
			}, config);

			return this.Ajax(url, method, JSON.stringify(form.data()), mergedConfig, form);
		},

		showToast(message, type = 'success') {
			let container = document.querySelector('[data-message-container]');
			if (!container) return;

			let toast = document.createElement('div');
			toast.className = `toast align-items-center text-white bg-${type} border-0`;
			toast.setAttribute('role', 'alert');
			toast.setAttribute('aria-live', 'assertive');
			toast.setAttribute('aria-atomic', 'true');
			toast.innerHTML = `
                <div class="d-flex">
                    <div class="toast-body">${message}</div>
                    <button type="button" class="close text-white mr-2 m-auto" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            `;

			container.appendChild(toast);

			$(toast).toast({ delay: 4000 });
			$(toast).toast('show');
			$(toast).on('hidden.bs.toast', () => toast.remove());
		},
	},
};